var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconVisibilityMGreen(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 26,
    viewBox: "0 0 38 26",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 0.5C10.6667 0.5 3.55002 5.68333 0.666687 13C3.55002 20.3167 10.6667 25.5 19 25.5C27.3334 25.5 34.45 20.3167 37.3334 13C34.45 5.68333 27.3334 0.5 19 0.5ZM19 21.3333C14.4 21.3333 10.6667 17.6 10.6667 13C10.6667 8.4 14.4 4.66667 19 4.66667C23.6 4.66667 27.3334 8.4 27.3334 13C27.3334 17.6 23.6 21.3333 19 21.3333ZM19 8C16.2334 8 14 10.2333 14 13C14 15.7667 16.2334 18 19 18C21.7667 18 24 15.7667 24 13C24 10.2333 21.7667 8 19 8Z",
    fill: "#008148"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisibilityMGreen);
export default __webpack_public_path__ + "static/media/icon-visibility-m-green.152ee20567940529cbedea8fb8fac207.svg";
export { ForwardRef as ReactComponent };